import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Airtable from "airtable";
import logo from "./logo-sigal_3.png";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import styled from "styled-components";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "./OrderDetails.css";

let base = new Airtable({
	apiKey:
		"patBXQgJPv4W41ktc.c7c4725c447b5fbef08fcd945de907f7ff20eb53ee6213c0f546fc811def4547",
}).base("appzz2xABAjzkSNOs");

const sizes = {
	amount: { marketing: "כמות", office: "כמות" },
	2: { child: "2" },
	"S/39/4": { shoes: "39", adult: "S", child: "4" },
	"M/40/6": { shoes: "40", adult: "M", child: "6" },
	"L/41/8": { shoes: "41", adult: "L", child: "8" },
	"XL/42/10": { shoes: "42", adult: "XL", child: "10" },
	"2XL/43/12": { shoes: "43", adult: "2XL", child: "12" },
	"3XL/44/14": { shoes: "44", adult: "3XL", child: "14" },
	"4XL/45/16": { shoes: "45", adult: "4XL", child: "16" },
	"5XL/46/18": { shoes: "46", adult: "5XL", child: "18" },
	36: { shoes: "36" },
	"36-5": { shoes: "36.5" },
	37: { shoes: "37" },
	"37-5": { shoes: "37.5" },
	38: { shoes: "38" },
	"38-5": { shoes: "38.5" },
	"39-5": { shoes: "39.5" },
	"40-5": { shoes: "40.5" },
	"41-5": { shoes: "41.5" },
	"42-5": { shoes: "42.5" },
	"43-5": { shoes: "43.5" },
	"44-5": { shoes: "44.5" },
	"45-5": { shoes: "45.5" },
	"46-5": { shoes: "46.5" },
	47: { shoes: "47" },
	"47-5": { shoes: "47.5" },
	48: { shoes: "48" },
	"One Size": { adult: "One Size" },
};

const InfoDiv = (props) => {
	return (
		<div>
			{props.name}:{" "}
			<span style={{ textDecoration: "underline", whiteSpace: "pre" }}>
				{!props.val ||
				props.val === "" ||
				(Array.isArray(props.val) && props.val.length > 0 && !props.val[0])
					? " ".repeat(props.placeTimes ?? 50)
					: props.val}
			</span>
		</div>
	);
};

const InfoSpan = (props) => {
	return (
		<span style={{ ...props.style }}>
			{props.name}:{" "}
			<span
				style={{
					textDecoration: "underline",
					whiteSpace: "pre",
					fontWeight: "normal",
				}}
			>
				{!props.val || props.val === ""
					? " ".repeat(props.placeTimes ?? 50)
					: props.val}
			</span>
		</span>
	);
};

const TopPart = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	flex-direction: column;
`;

const Header = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;

	@media screen and (max-width: 40em) {
		flex-direction: column-reverse;
		margin-bottom: 30px;
	}
`;

const BottomPart = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;

	& .part1 {
		display: flex;
		flex-direction: column;
		max-width: 50%;
	}

	& .part2 {
		display: flex;
		flex-direction: column-reverse;
		max-width: 60%;
		gap: 8px;
	}

	@media screen and (max-width: 40em) {
		padding-bottom: 24px;
		justify-content: center;
		& .part1 {
			max-width: 100%;
		}

		& .part2 {
			max-width: 100%;
		}
	}
`;

function useInput({ type }) {
	const [value, setValue] = useState("");
	const input = (
		<input
			value={value}
			onChange={(e) => setValue(e.target.value)}
			type={type}
		/>
	);
	return [value, input];
}

const SupplierDetails = (props) => {
	const [orderDetails, setOrderDetails] = useState({});
	const [orderItems, setOrderItems] = useState([]);
	const routerParams = useParams();
	const [approverName, approverNameInput] = useInput({ type: "text" });
	const [approverId, approverIdInput] = useInput({ type: "text" });

	useEffect(() => {
		base("הזמנות ספקים").find(routerParams.id, function (err, record) {
			if (err) {
				setOrderDetails({ error: "הזמנה לא קיימת במערכת" });
				console.error(err);
				return;
			}
			setOrderDetails(record.fields);
		});
	}, [routerParams.id]);

	useEffect(() => {
		let newItems = [];
		base("פריטי הזמנות ספקים")
			.select({
				view: "API",
				filterByFormula: `{הזמנה} = '${orderDetails["מס הזמנה"]}'`,
			})
			.eachPage(
				function page(records, fetchNextPage) {
					const fieldsM = records.map((rec) => rec.fields);
					newItems = [...newItems, ...fieldsM];

					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						setOrderItems({ error: "חלה שגיאה בקריאת הנתונים" });
						return;
					}

					setOrderItems(newItems);
				}
			);
	}, [orderDetails]);

	const getItemSizes = (item) => {
		let type = "shoes";
		let itemType =
			item.rawType && item.rawType !== "" ? item.rawType : item.type[0];
		switch (itemType) {
			case "בוגרים":
				type = "adult";
				break;
			case "הדפסים":
				type = "adult";
				break;
			case "ילדים":
				type = "child";
				break;
			case "נעליים":
				type = "shoes";
				break;
			default:
				type = "shoes";
				break;
		}
		const itemSizes = Object.keys(sizes)
			.filter((size) => item[size] && item[size] !== 0)
			.map((size, idx) => {
				return (
					<>
						{idx > 0 && <> | </>}
						<InfoSpan name={sizes[size][type]} val={item[size] + ""} />
					</>
				);
			});

		return itemSizes;
	};

	const isGoodId = (id) => {
		id = String(id).trim();
		if (id.length > 9 || isNaN(id)) return false;
		id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
		return (
			Array.from(id, Number).reduce((counter, digit, i) => {
				const step = digit * ((i % 2) + 1);
				return counter + (step > 9 ? step - 9 : step);
			}) %
				10 ===
			0
		);
	};

	const approveOrder = () => {
		if (approverName.length < 2 || !approverName.includes(" ")) {
			alert("שם מלא לא תקין");
			return;
		}
		if (approverId.length === 0 || !isGoodId(approverId)) {
			alert("ת״ז לא תקינה");
			return;
		}

		if (
			!window.confirm(
				"האם אתם בטוחים שהפרטים שהזנתם תקינים? לא ניתן לשנות פרטים אלו לאחר אישור ההזמנה"
			)
		)
			return;

		base("הזמנות ספקים").update(
			[
				{
					id: routerParams.id,
					fields: {
						"אישור הזמנה לקוח": true,
						"שם מאשר הזמנה": approverName,
						"תז לקוח מאשר": approverId,
					},
				},
			],
			function (err, records) {
				if (err) {
					console.error(err);
					return;
				}

				window.alert("ההזמנה אושרה!\nתודה רבה, סיגל בגדי עבודה");
				window.location.reload();
			}
		);
	};

	const sortedOrderItems = orderItems.sort((a, b) => {
		const aCheck =
			a["מספר הזמנת לקוח"] && a["מספר הזמנת לקוח"][0]
				? a["מספר הזמנת לקוח"][0]
				: 0;
		const bCheck =
			a["מספר הזמנת לקוח"] && a["מספר הזמנת לקוח"][0]
				? a["מספר הזמנת לקוח"][0]
				: 0;
		if (aCheck < bCheck) return -1;
		if (aCheck > bCheck) return 1;
		return 0;
	});

	const adult = sortedOrderItems.filter((item) => item.rawType === "בוגרים");
	const children = sortedOrderItems.filter((item) => item.rawType === "ילדים");
	const shoes = sortedOrderItems.filter((item) => item.rawType === "נעליים");
	const marketing = sortedOrderItems.filter(
		(item) => item.rawType === "מוצרי פרסום"
	);
	const office = sortedOrderItems.filter(
		(item) => item.rawType === "דפוס ומשרד"
	);

	return (
		<div
			style={{
				fontFamily: "Assistant, sans-serif",
				color: "#804c9e",
				fontWeight: "bold",
				padding: "20px",
				width: "100%",
				height: "100vh",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<TopPart>
				<Header>
					<div style={{ display: "flex", flexDirection: "column" }}>
						<span>
							<span style={{ fontSize: "26px" }}>הזמנת רכש</span> מס׳:{" "}
							{orderDetails["מס הזמנה"]}
						</span>
						<InfoDiv
							name="תאריך"
							val={new Date(orderDetails["תאריך הזמנה"]).toLocaleDateString()}
						/>
					</div>
					<div style={{ textAlign: "center" }}>
						<div>
							תמנע 7 חולון 5881307 | טל' 03-5580668 | פקס 03-5591101
							<br />
							ח.פ 513830638 | www.sigal-ba.co.il
						</div>
						<br />
					</div>
					<img width="300px" alt="logo" src={logo} />
				</Header>
				<div
					style={{
						display: "grid",
						gridTemplateAreas: `
						'main1 main2 comments'
						'main3 main4 comments'
						'main5 main5 comments'`,
						gap: "8px",
						flexWrap: "wrap",
					}}
				>
					<InfoDiv
						style={{ gridArea: "main1" }}
						name="שם הספק"
						val={orderDetails["שם הספק"]}
					/>
					<InfoDiv
						style={{ gridArea: "main2" }}
						name="ח״פ/ע״מ"
						val={orderDetails["חפ"]}
					/>
					<InfoDiv
						style={{ gridArea: "main3" }}
						name="טלפון"
						val={orderDetails["phoneParsed"]}
					/>
					<InfoDiv
						style={{ gridArea: "main4" }}
						name="אימייל"
						val={orderDetails["מייל"]}
					/>
					<InfoDiv
						style={{ gridArea: "main5" }}
						name="כתובת"
						val={orderDetails["כתובת"]}
					/>
					<div style={{ gridArea: "comments" }}>
						הערות:{" "}
						<span
							style={{
								textDecoration: "underline",
								overflowWrap: "break-word",
							}}
						>
							{orderDetails["הערות להזמנה"]}
						</span>
					</div>
				</div>
			</TopPart>
			{adult.length > 0 && (
				<>
					<h5>בוגרים</h5>
					<div style={{ flexGrow: "1", padding: "0 20px" }}>
						<Table style={{ border: "1px solid black" }}>
							<Thead>
								<Tr style={{ minHeight: "80px" }}>
									<Th>פריט</Th>
									<Th>צבע</Th>
									<Th>
										<InfoSpan name="מידה" val="כמות" />
									</Th>
									<Th>כמות</Th>
									<Th>הערות</Th>
									<Th>מס׳ הזמנה לקוח</Th>
								</Tr>
							</Thead>
							<Tbody>
								{adult.map((item, idx) => (
									<Tr key={idx}>
										<Td>{item["itemName"]}</Td>
										<Td>{item["צבע"]}</Td>
										<Td>{getItemSizes(item)}</Td>
										<Td>{item["totalQuantity"]}</Td>
										<Td>{item["הערות/תיאור עבודה"]}</Td>
										<Td>{item["מספר הזמנת לקוח"]}</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</>
			)}
			{children.length > 0 && (
				<>
					<h5>ילדים</h5>
					<div style={{ flexGrow: "1", padding: "0 20px" }}>
						<Table style={{ border: "1px solid black" }}>
							<Thead>
								<Tr style={{ minHeight: "80px" }}>
									<Th>פריט</Th>
									<Th>צבע</Th>
									<Th>
										<InfoSpan name="מידה" val="כמות" />
									</Th>
									<Th>כמות</Th>
									<Th>הערות</Th>
									<Th>מס׳ הזמנה לקוח</Th>
								</Tr>
							</Thead>
							<Tbody>
								{children.map((item, idx) => (
									<Tr key={idx}>
										<Td>{item["itemName"]}</Td>
										<Td>{item["צבע"]}</Td>
										<Td>{getItemSizes(item)}</Td>
										<Td>{item["totalQuantity"]}</Td>
										<Td>{item["הערות/תיאור עבודה"]}</Td>
										<Td>{item["מספר הזמנת לקוח"]}</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</>
			)}
			{shoes.length > 0 && (
				<>
					<h5>נעליים</h5>
					<div style={{ flexGrow: "1", padding: "0 20px" }}>
						<Table style={{ border: "1px solid black" }}>
							<Thead>
								<Tr style={{ minHeight: "80px" }}>
									<Th>פריט</Th>
									<Th>צבע</Th>
									<Th>
										<InfoSpan name="מידה" val="כמות" />
									</Th>
									<Th>כמות</Th>
									<Th>הערות</Th>
									<Th>מס׳ הזמנה לקוח</Th>
								</Tr>
							</Thead>
							<Tbody>
								{shoes.map((item, idx) => (
									<Tr key={idx}>
										<Td>{item["itemName"]}</Td>
										<Td>{item["צבע"]}</Td>
										<Td>{getItemSizes(item)}</Td>
										<Td>{item["totalQuantity"]}</Td>
										<Td>{item["הערות/תיאור עבודה"]}</Td>
										<Td>{item["מספר הזמנת לקוח"]}</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</>
			)}
			{marketing.length > 0 && (
				<>
					<h5>מוצרי פרסום</h5>
					<div style={{ flexGrow: "1", padding: "0 20px" }}>
						<Table style={{ border: "1px solid black" }}>
							<Thead>
								<Tr style={{ minHeight: "80px" }}>
									<Th>פריט</Th>
									<Th>צבע</Th>
									<Th>מק״ט ספק</Th>
									<Th>כמות</Th>
									<Th>צבע הדפסה</Th>
									<Th>תיאור עבודה</Th>
									<Th>מיקום אספקה</Th>
									<Th>מס׳ הזמנה לקוח</Th>
								</Tr>
							</Thead>
							<Tbody>
								{marketing.map((item, idx) => (
									<Tr key={idx}>
										<Td>{item["itemName"]}</Td>
										<Td>{item["צבע"]}</Td>
										<Td>{item["מקט ספק"]}</Td>
										<Td>{item["totalQuantity"]}</Td>
										<Td>{item["צבע הדפסה"]}</Td>
										<Td>{item["הערות/תיאור עבודה"]}</Td>
										<Td>{item["מיקום אספקה"]}</Td>
										<Td>{item["מספר הזמנת לקוח"]}</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</>
			)}
			{office.length > 0 && (
				<>
					<h5>דפוס ומשרד</h5>
					<div style={{ flexGrow: "1", padding: "0 20px" }}>
						<Table style={{ border: "1px solid black" }}>
							<Thead>
								<Tr style={{ minHeight: "80px" }}>
									<Th>פריט</Th>
									<Th>מק״ט ספק</Th>
									<Th>כמות</Th>
									<Th>הערות</Th>
								</Tr>
							</Thead>
							<Tbody>
								{office.map((item, idx) => (
									<Tr key={idx}>
										<Td>{item["itemName"]}</Td>
										<Td>{item["מקט ספק"]}</Td>
										<Td>{item["totalQuantity"]}</Td>
										<Td>{item["הערות/תיאור עבודה"]}</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</>
			)}
			<BottomPart className="pagebreak">
				<div className="part1">
					{/* הערות כלליות:{" "}
					<div
						style={{ textDecoration: "underline", overflowWrap: "break-word" }}
					>
						{orderDetails["הערות להזמנה"]}
					</div> */}
				</div>
				<div className="part2">
					{/* <div
						style={{
							border: "1px solid #804c9e",
							display: "flex",
							gap: "16px",
							flexWrap: "wrap",
							justifyContent: "space-evenly",
							padding: "0 8px",
						}}
					></div> */}
				</div>
			</BottomPart>
			{Object.keys(orderDetails).length === 0 && (
				<div
					style={{
						position: "absolute",
						top: "0",
						left: "0",
						width: "100%",
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						background: "white",
					}}
				>
					<img width="300px" alt="logo" src={logo} />
					טוען, אנא המתינו...
				</div>
			)}

			{orderDetails["error"] && (
				<div
					style={{
						position: "absolute",
						top: "0",
						left: "0",
						width: "100%",
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						background: "white",
					}}
				>
					<img width="300px" alt="logo" src={logo} />
					{orderDetails["error"]}
				</div>
			)}
		</div>
	);
};

export default SupplierDetails;
